import React, { useCallback } from 'react';
import { TextField } from '@mui/material';

const LanguagesTextbox = ({ language, setLanguage }) => {
  // Moved the updateLanguage function here so the parent stays clean
  const updateLanguage = useCallback((lang) => {
    let newLanguageValue = (language.length > 0 && language.lastIndexOf(",") === language.length - 1) 
      ? language.substring(0, language.length - 1) 
      : language;
      
    newLanguageValue += lang;

    setLanguage(
      (newLanguageValue.length > 0 && newLanguageValue.indexOf(",") === 0) 
        ? newLanguageValue.substring(1, newLanguageValue.length - 1) 
        : newLanguageValue
    );
  }, [language, setLanguage]);

  const languagesList = [
    "English", "Hindi", "Kannada", "Urdu", "Tamil", "Telugu", 
    "Malayalam", "Marathi", "Punjabi", "Bangla", "Arabic", 
    "French", "Spanish", "Russian"
  ];

  return (
    <div className='Candidate_Languages'>
      <TextField
        sx={{ width: "350px", marginTop: "2px" }}
        id="Candidate_Languages"
        size="small"
        label="Languages"
        variant="outlined"
        value={language || ""}
        onChange={(e) => {
          const val = e.target.value;
          setLanguage(val.length > 0 && val.slice(0, 1) === "," ? val.substring(1, val.length) : val);
        }}
      />
      <div style={{ textAlign: "center", fontSize: "small", marginTop: "3px" }}>
        {languagesList.map((lang) => (
          !(language || "").includes(lang) ? (
            <button 
              key={lang}
              style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} 
              onClick={() => updateLanguage(`,${lang},`)}
            >
              {lang}
            </button>
          ) : null
        ))}
        <button 
          style={{ margin: "2px", border: "1px solid", padding: "2px 6px" }} 
          onClick={() => setLanguage("")}
        >
          Clear
        </button>
        <br />
      </div>
    </div>
  );
};

export default LanguagesTextbox;